module.exports = __webpack_public_path__ + "img/sonic.c4a78ae0.jpg";